import React, { useContext } from "react";
import { AuthContext } from "../AppContext";

const DarkMode = () => {
  const {setTheme} = useContext(AuthContext)

  let clickedClass = "clicked";
  const body = document.documentElement;
  const lightTheme = "light";
  const darkTheme = "dark";
  let theme;

  if (localStorage) {
    theme = localStorage.getItem("theme");
  }

  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme);
  } else {
    body.classList.add(lightTheme);
  }

  const switchTheme = (e) => {
    if (theme === darkTheme) {
      body.classList.replace(darkTheme, lightTheme);
      e.target.classList.remove(clickedClass);
      localStorage.setItem("theme", "light");
      theme = lightTheme;
      setTheme(lightTheme)
    } else {
      body.classList.replace(lightTheme, darkTheme);
      e.target.classList.add(clickedClass);
      localStorage.setItem("theme", "dark");
      theme = darkTheme;
      setTheme(darkTheme)

    }
  };

  return (
    <div className="darkmode-switch">
    <button className={theme === "dark" ? clickedClass : ""} id="darkMode" onClick={(e) => switchTheme(e)}></button>
    </div>
  );
};

export default DarkMode;